import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#D4A24C', // Gold
      light: '#E8C078',
      dark: '#B9852E',
      contrastText: '#0F2E2B', // Ink
    },
    secondary: {
      main: '#E4572E', // Coral
      contrastText: '#F5F1E6',
    },
    background: {
      default: '#0F2E2B', // Deep Ink
      paper: '#153A35', // Soft Ink
    },
    text: {
      primary: '#F5F1E6', // Light text
      secondary: 'rgba(245, 241, 230, 0.66)', // Dim text
    },
    divider: 'rgba(245, 241, 230, 0.14)', // Custom line color
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Fraunces", serif',
      fontWeight: 600,
    },
    h2: {
      fontFamily: '"Fraunces", serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: '"Fraunces", serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Fraunces", serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Fraunces", serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Fraunces", serif',
      fontWeight: 700,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '999px',
          padding: '10px 20px',
          transition: 'all 0.2s ease-in-out',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
});

export default theme;
